import React, { Component } from 'react'
import { sessionManager } from '../../core/SessionManager';
import { Layout, Typography, Radio, Space, Button, Form, Spin, notification } from 'antd';
import { post } from '../../utils/http'
import api from '../../utils/api';
import { LoadingOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Content } = Layout;

class StoreList extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            merchantList: sessionManager.getUserInfo().storeList,
            loading: false
        })
    }

    goHomePage = () => {
        const { merchant } = this.state;
        this.setState({ loading: true });
        var confirmData = new FormData();
        confirmData.append("merchantId", merchant);
        var _this = this;
        sessionManager.setMerchantId(merchant);
		post(api.telepinDoLogin, confirmData).then(function(response){
			sessionManager.setPrivilege(response.privilege);
			sessionManager.setIsAdmin(response.isAdmin);
			sessionManager.setMerchant(response.merchant);
			sessionManager.setIsSMRTNonCFOUser(response.isSMRTNonCFOUser);
			sessionManager.setNeedChangePassword(response.needChangePassword);
			sessionManager.setTemporaryPassword(response.temporaryPassword);
			sessionManager.setUserAuthenticatedTime(response.userAuthenticatedTime);
            sessionManager.setMerchantName(response.merchantName);
            var confirmData1 = new FormData();
            confirmData1.append("merchantId", merchant);
            confirmData1.append("userRole", 3);
            post(api.getMenuList, confirmData1).then(function (response) {
                sessionManager.setMenuList(response);
                _this.setState({ loading: false }, () => {
                    _this.props.history.push('./page/home')
                });
            }).catch(function (error) {
                notification['error']({
                    message: error
                })
                _this.setState({ loading: false });
            })
		}).catch(function(error){
			console.log(error);
            _this.setState({ loading: false });
            notification['error']({
                message: 'Fail to login.',
            });
		})
    };

    goBack = () => {
        let _this = this
        post(api.removePrivilege).then(function (response) {
            _this.removePrivilege()
        }).catch(function (error) {
            _this.removePrivilege()
        })
    };

    removePrivilege = () => {
        sessionManager.signout();
        this.props.history.push('./login')
    }

    render() {
        const { merchantList, loading, merchant } = this.state;
        return (
            <>
                <Layout style={{ background: 'white', paddingTop: '200px' }}>
                    <Content style={{ textAlign: 'center' }}>
                        <Title>Dash Portal</Title>
                        <Title style={{ marginBottom: '20px' }} level={5}>You have {merchantList.length} accounts linked to this user</Title>
                        <Form name="user merchant list" initialValues={{ "user merchant list": sessionManager.getUserId() }}>
                            <Form.Item name="user merchant list">
                                <Radio.Group style={{ marginLeft: '50px' }} value={merchant} size="large" onChange={(event) => { this.setState({ merchant: event.target.value }) }}>
                                    <Space direction="vertical">
                                        {merchantList.map((m) => {
                                            return (
                                                <Radio style={{ fontSize: '22px', width: '350px' }} key={m.merchantId} value={m.merchantId}>
                                                    {m.merchantName}
                                                </Radio>
                                            )
                                        })}
                                    </Space>
                                </Radio.Group>
                            </Form.Item>
                        </Form>

                        <div style={{ marginTop: '50px' }}>
                            {!loading && <Button type="primary" onClick={this.goHomePage}>
                            CONFIRM
                            </Button>}
                            {loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                            <Button onClick={this.goBack} style={{ marginLeft: '30px' }}>
                                LOGOUT
                            </Button>
                        </div>
                    </Content>
                </Layout>
            </>
        );

    }

};
export default StoreList;